<script setup lang="ts">
import { CategoryCoverProps } from "./CategoryCover.props"

defineProps<CategoryCoverProps>()

const emit = defineEmits<{ (e: "onFollow"): void }>()

const handleFollow = () => emit("onFollow")
</script>

<template>
  <div class="category-cover-wrapper relative flex flex-col overflow-hidden">
    <UtilsWrapperImage
      v-if="image"
      :="image"
      :img-attrs="{ fetchpriority: 'high' }"
      :key="image.image.url"
      class="wrapper-image-full-container-centered wrapper-image-fixed-232"
      activateFocalPoint
      :focalPoint="image.focalPoint"
    />

    <UtilsButton
      v-if="path"
      @click="handleFollow"
      :text="$t('productBlocks.brandBlock.categoryCover.follow')"
      :path="path"
      theme="outlined-green"
      class="mt-6 inline-flex justify-center [&>span]:px-6 md:[&>span]:px-10"
    />
  </div>
</template>
